import React, { useRef, useState } from 'react'
import { FlashMessage, GlobalLoader, InputField } from '@reactiveonline/reactive_admin_shared-packages'
import LanguagePicker from '../shared/LanguagePicker'

export default function Edit({ adminInterfaceLogo, applicationName, token, updatePasswordPath }) {
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [passwordShown, setPasswordShown] = useState(false)
  const [confirmPasswordShown, setConfirmPasswordShown] = useState(false)
  const [passwordValidator, setPasswordValidator] = useState({})
  const [loading, setLoading] = useState(false)

  const flashMessageRef = useRef(null)

  const disableSave = !(passwordValidator.length && passwordValidator.number && passwordValidator.uppercase && passwordValidator.lowercase && newPassword === confirmPassword)

  const handlePassword = event => {
    const value = event.target.value
    let validations = {}

    if (value.length >= 8) {
      validations = { ...validations, length: true }
    }
    if (value.match(/^.*\d.*$/)) {
      validations = { ...validations, number: true }
    }
    if (value.match(/^.*[A-Z].*$/)) {
      validations = { ...validations, uppercase: true }
    }
    if (value.match(/^.*[a-z].*$/)) {
      validations = { ...validations, lowercase: true }
    }

    setPasswordValidator(validations)
    setNewPassword(value)
  }

  const handleSubmit = event => {
    event.preventDefault()

    if (disableSave) {
      flashMessageRef.current.show(Cas.translations.password_validation_alert, 'error')

    } else {
      save()
    }
  }

  const save = () => {
    setLoading(true)

    const fd = new FormData()
    fd.append('administrator[password]', newPassword)
    fd.append('administrator[password_confirmation]', confirmPassword)
    fd.append(`administrator[reset_password_token]`, token)

    Rails.ajax({
      type: 'PUT',
      url: updatePasswordPath,
      dataType: 'json',
      data: fd,
      success: res => {
        if (res.redirectUrl) {
          window.location.href = res.redirectUrl
        } else {
          setLoading(false)
        }
      },
      error: res => {
        flashMessageRef.current.show(res.error, 'error')
        setLoading(false)
      }
    })
  }

  return (
    <>
      <div className='flex-box flex-column items-center content-center authentication-wrapper'>
        <div className="auth-box">
          <div className="left-side-wrapper">
            <div className="logo">
              <img src={ adminInterfaceLogo } />
            </div>

            <div className='authentication-language-picker-wrapper'>
              <LanguagePicker />
            </div>

            <div className="headline">
              <h1 className='m-b-10'>
                { applicationName }
              </h1>
              <div>
                { Partners.translations.administrator.change_password_header }
              </div>
            </div>

            <div className='form'>
              <div className='row'>
                <div className='field' style={{ position: 'relative' }}>
                  <InputField
                    className='input-field'
                    label={ Partners.translations.administrator.attributes.new_password }
                  >
                    <input
                      type={ passwordShown ? 'text' : 'password' }
                      value={ newPassword }
                      onChange={ handlePassword }
                    />
                  </InputField>
                  { newPassword.length > 0 &&
                    <div style={{ position: 'absolute', right: '15px', top: '30px', fontSize: '14px' }}>
                      <i 
                        className={ `pointer fa-light ${ passwordShown ? 'fa-eye-slash' : 'fa-eye' }` }
                        onClick={ () => setPasswordShown(prevState => !prevState) } 
                      />
                    </div>
                  }
                </div>

                <div className='field' style={{ position: 'relative' }}>
                  <InputField
                    className='input-field'
                    label={ Partners.translations.administrator.attributes.password_confirmation }
                  >
                    <input
                      type={ confirmPasswordShown ? 'text' : 'password' }
                      value={ confirmPassword }
                      onChange={ e => setConfirmPassword(e.target.value) }
                    />
                  </InputField>
                  { confirmPassword.length > 0 &&
                    <div style={{ position: 'absolute', right: '15px', top: '30px', fontSize: '14px' }}>
                      <i 
                        className={ `pointer fa-light ${ confirmPasswordShown ? 'fa-eye-slash' : 'fa-eye' }` }
                        onClick={ () => setConfirmPasswordShown(prevState => !prevState) } 
                      />
                    </div>
                  }
                </div>

                <div className='field flex-box flex-wrap items-center content-space-between'>
                  <div 
                    className={`pass-validator ${ passwordValidator.length ? '' : 'invalid' } `}
                  >
                    { Partners.translations.administrator.attributes.password_length }
                  </div>
                  <div 
                    className={`pass-validator pass-validator-right ${ passwordValidator.number ? '' : 'invalid' } `}
                  >
                    { Partners.translations.administrator.attributes.password_number }
                  </div>
                  <div 
                    className={`pass-validator ${ passwordValidator.uppercase ? '' : 'invalid' } `}
                  >
                    { Partners.translations.administrator.attributes.password_uppercase }
                  </div>
                  <div 
                    className={`pass-validator pass-validator-right ${ passwordValidator.lowercase ? '' : 'invalid' } `}
                  >
                    { Partners.translations.administrator.attributes.password_lowercase }
                  </div>
                </div>

                <div className='actions'>
                  { !loading &&
                    <div className='flex-box items-center content-center'>
                      <button 
                        type='submit' 
                        className={ `btn ${ disableSave ? 'disabled' : '' }` } 
                        onClick={ handleSubmit }
                      >
                        { Partners.translations.administrator.change_password }
                      </button>
                    </div>
                  }
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      { loading && <GlobalLoader fullPage /> }

      <FlashMessage ref={ flashMessageRef } />
    </>
  )
}
